/**
 * Memory text is stored in the third person ("his old motorcycle he called Bessie"), the way
 * the care team reads it. On the resident's own screen it speaks to them ("your old
 * motorcycle you called Bessie"). Whole words only, so a name such as Herman, Shelby or
 * Hisham is never touched, and "her" reads "you" where it is the object ("here with her at
 * Shady Acres") and "your" where it owns something ("her rose garden").
 */

const AFTER_OBJECT = /^(?:$|[.,;:!?)\]]|\s+(?:at|in|on|to|for|with|and|or|but|here|there|when|while|because|every|each|today|yesterday)\b)/i;

/** "he is" -> "you are", "she was" -> "you were", "he has" -> "you have", "he's" -> "you're". */
const SUBJECT_VERBS: Array<[RegExp, string]> = [
  [/\b(he|she) is\b/gi, '$1 are'],
  [/\b(he|she) was\b/gi, '$1 were'],
  [/\b(he|she) has\b/gi, '$1 have'],
  [/\b(he|she) does\b/gi, '$1 do'],
  [/\b(he|she)'s\b/gi, "$1're"],
  [/\b(he|she)’s\b/gi, '$1’re'],
];

const matchCase = (src: string, out: string) => (src[0] === src[0].toUpperCase() ? out[0].toUpperCase() + out.slice(1) : out);

export function toSecondPerson(text: string): string {
  if (!text) return text;
  let s = text;
  for (const [re, to] of SUBJECT_VERBS) s = s.replace(re, to);
  s = s.replace(/\b(himself|herself)\b/gi, (m) => matchCase(m, 'yourself'));
  s = s.replace(/\b(his)\b/gi, (m) => matchCase(m, 'your'));
  s = s.replace(/\b(he|she|him)\b/gi, (m) => matchCase(m, 'you'));
  // "her" owns something unless the next word ends the phrase ("with her at", "tell her.").
  s = s.replace(/\bher\b/gi, (m: string, offset: number, whole: string) => matchCase(m, AFTER_OBJECT.test(whole.slice(offset + m.length)) ? 'you' : 'your'));
  return s;
}
